import React from 'react';
import NavigationBar from '../NavigationBar/NavigationBar';
import './styles.scss';

// Frame of every invitation screen. The content flows and scrolls, so short
// phones and an open keyboard keep the primary action reachable.
const InvitationLayout = ({ children }: { children: React.ReactNode }) => (
  <div className='invitation-layout'>
    <NavigationBar />
    <div className='invitation-layout-body'>
      <main className='invitation-layout-content'>
        <div className='invitation-layout-column'>{children}</div>
      </main>
      <div
        className='invitation-layout-image'
        style={{ backgroundImage: 'url("/rest-illustration.png")' }}
        aria-hidden
      />
    </div>
  </div>
);

export default InvitationLayout;
